import { CommonModule } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { FuseSidebarComponent } from '@fuse/components/sidebar/sidebar.component';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseConfigService } from '@fuse/services/config.service';
import { LoaderService } from 'app/main/utils/service/loader.service';
import { asapScheduler, Subject } from 'rxjs';
import { observeOn, takeUntil } from 'rxjs/operators';
import { navigation } from '../../../navigation/navigation';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { QuickPanelComponent } from '../../components/quick-panel/quick-panel.component';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';
import { ManualeComponent } from 'app/layout/components/manuale/manuale.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    CdkScrollable,
    RouterModule,
    MatProgressSpinnerModule,
    FuseSidebarComponent,
    FusePerfectScrollbarDirective,
    NavbarComponent,
    QuickPanelComponent,
    ToolbarComponent,
    ManualeComponent
  ],
  selector: 'vertical-layout-1',
  templateUrl: './layout-1.component.html',
  styleUrls: ['./layout-1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VerticalLayout1Component implements OnInit, OnDestroy {
  fuseConfig: any;
  navigation: any;
  loading = false;

  shouldQuickPanelBeOpenable = this.fuseSidebarService.quickPanelHasOpened;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private _fuseConfigService: FuseConfigService,
    private fuseSidebarService: FuseSidebarService,
    private loaderService: LoaderService
  ) {
    // Set the defaults
    this.navigation = navigation;

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.fuseConfig = config;
    });
    // Page initialization can start HTTP after this layout's bindings have been checked.
    this.loaderService.isLoading.pipe(observeOn(asapScheduler), takeUntil(this._unsubscribeAll)).subscribe(loading => {
      this.loading = loading;
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
}
